import styled from 'styled-components';
import { Link } from 'gatsby';

import { MEDIA_QUERIES } from "@constants";

export const PostsHeroContentDIV = styled.div`
  h1 {
    max-width: var(--text-max-width);
  }

  p {
    color: var(--color--charcoal-900);
    margin: 0 0 var(--spacing--M);
  }

  .large-icon {
    position: absolute !important;
    right: -30px;
    z-index: 0;
    width: 50%;
    min-width: 197px;
    max-width: 458px;
    transform:translateY(calc(var(--spacing--L) * -1)) scale(0.70); /* ensure that illustration doesn't overlap the top header and scale down so it doesn't overlap the blog category description text */
    transform-origin: center top;

    ${MEDIA_QUERIES.M} {
      display: block;
      width: 50%;
    }

    ${MEDIA_QUERIES.XL} {
      right: 96px;
    }
  }

  p.posts-hero-description {
    max-width: max(616px, calc((var(--container-width) / 12 * 6) - (var(--spacing--M) * 6 / 12)));
  }

  .is-archive & {
    padding-top: 30px;
  }
`;

export const PostsHeroDIV = styled.div`
  position: relative;
  background: linear-gradient(180deg, rgba(var(--color--slate-100-rgb), 0.5), rgba(var(--color--slate-100-rgb), 0));
  margin-bottom: var(--spacing--L);
`;

export const PostsHeroTopicsNAV = styled.nav`
  position: relative;

  &::after {
    content: '';
    display: block;
    width: calc((100vw - var(--container-width)) / 2);
    height: var(--button--height-S);
    position: absolute;
    top: 50%;
    right: calc((100vw - var(--container-width)) / -2);
    transform: translateY(-50%);
    background: linear-gradient(90deg, rgba(255, 255, 255, 0), white);
    pointer-events: none;
  }
`;

export const PostsHeroTopicsScrollerDIV = styled.div`
  margin: var(--spacing--base-1-5) calc((100vw - var(--container-width)) / -2) calc(var(--spacing--base-2) * -1);
  padding: var(--spacing--base-2) calc((100vw - var(--container-width)) / 2);
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }
  
  ${MEDIA_QUERIES.M} {
    margin-top: 20px;
    margin-bottom: -40px;
    padding-top: 40px;
    padding-bottom: 40px;
  }
`;

export const PostsHeroTopicsLinksDIV = styled.div`
  display: flex;
  width: fit-content;
  gap: var(--spacing--base-1);
`;


export const PostsHeroTopicsLINK = styled(Link)`
  border-radius: var(--border-radius--S);
  color: var(--color--text-light);
  display: block;
  font-size: var(--font-size--S);
  height: var(--button--height-S);
  line-height: var(--button--height-S);
  padding: 0 var(--button--padding-x-S);
  white-space: nowrap;

  &:hover {
    color: var(--color--text-headline);
    background: var(--color--charcoal-100);
  }

  &.is-active {
    color: var(--color--text-headline);
    background: var(--color--charcoal-200);
  }
`;
